import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { Permission } from "@shared/models/permissions"
import type LessonEditor from "cc-frontend/services/lesson-editor"
import type { ModelsNeededForFirstEdit } from "cc-frontend/services/lesson-editor"
import styles from "./title.module.css"

interface Sig {
  Args: {
    modelsNeededForFirstEdit: ModelsNeededForFirstEdit
    cardStackId: string
    modelId: string
    value: string | null
    permissions: Array<Permission>
  }
  Element: HTMLDivElement
}

export default class Title extends Component<Sig> {
  readonly styles = styles

  @service declare lessonEditor: LessonEditor

  @action
  updateSection(id, prop, value) {
    this.lessonEditor.editCard(
      this.args.modelsNeededForFirstEdit,
      this.args.cardStackId,
      id,
      prop,
      value
    )
  }

  @action
  finishedEditing(id, prop, value, originalValue, wordCountChange) {
    this.lessonEditor.finishEditingCard(
      this.args.modelsNeededForFirstEdit,
      this.args.cardStackId,
      id,
      prop,
      value,
      originalValue,
      wordCountChange
    )
  }
}
